var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('img',{staticClass:"sbjj",attrs:{"src":require("@public/img/hotApply/icon_sbjj.jpg")}})]),_c('p',{staticClass:"title"},[_vm._v("长按图片，识别身边警局小程序")])])
}]

export { render, staticRenderFns }